import React from "react"
import Image from "@components/image"
import SidebarColumnsInfo from "./sidebar-columns-info"
import Icon from "./icon"
import { useSidebarStore } from "@src/hooks/useStore"
import useToggleStates from "@src/hooks/useToggleStates"

const InfoColumns = ({ items, title, showPopup }) => {
  const { sidebarOpened, setContent, setSettings } = useSidebarStore(["sidebarOpened", "setContent", "setSettings"])

  const { toggleAllFunction } = useToggleStates()

  const handleClick = () => {
    toggleAllFunction("sidebar", !sidebarOpened)
    setContent(<SidebarColumnsInfo items={items} />)
    setSettings({showSearchBar: false})
  }

  return (
    <div className="p-7 lg:py-10 lg:px-12 w-full relative bg-sage rounded-xl">
      {title && (
        <h2 tabIndex={0} className="w-full text-center pb-5">
          {title}
        </h2>
      )}
      {showPopup && <Icon onClick={handleClick} />}
      <div className="flex gap-8 md:gap-0 flex-col md:flex-row justify-around md:items-center">
        {items?.map((item, index) => (
          <div
            className="p-1 md:p-5 lg:py-5 lg:px-6 xl:px-10 flex flex-col md:justify-between gap-5 rounded-xl"
            key={index}
          >
            <div className="flex flex-row items-center">
              <Image
                className="!h-7 !w-9 md:!w-10 md:!h-10 "
                maxWidth={40}
                height={40}
                image={item?.image}
                objectFit="contain"
              />
              <div className="pl-8 md:pl-4 lg:pl-8 max-md:w-full max-md:flex max-md:gap-y-2.5 max-md:flex-col">
                <p className="font-owners text-base lg:text-xl font-medium leading-4 md:leading-7 tracking-wider text-gray-900 ">
                  {item?.title}
                </p>
                <p className="font-owners-text text-sm lg:text-base font-normal leading-7 text-gray-900 max-md:leading-none">
                  {item?.subTitle}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default InfoColumns
